import { type SVGAttributes } from "react";

export function ExternalLinkIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.4301 15.6048L15.4226 8.53373L8.35152 8.54124"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M15.0696 8.8877L8.00529 15.9655"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
